import { Box, Button } from '@bechtel/gds';
import styled, { css } from 'styled-components';

export const LayoutButtonStyled = styled(Button)`
  ${({ theme }) => css`
    padding: ${theme.spacings[450]} ${theme.spacings[600]};
    width: 100px;
    font-weight: ${theme.fontWeights[600]};
    margin-right: ${theme.spacings[400]};
  `};
`;

export const MessageTypeStyled = styled(Box).attrs({
  flexDirection: { sm: 'column' },
  alignItems: { sm: 'center' },
  justifyContent: { sm: 'center' },
  m: { sm: '300' },
})`
  ${({ theme }) => css`
    width: ${theme.spacings[700]};
    height: ${theme.spacings[700]};
    border-radius: ${theme.radii[100]};
    background-color: ${theme.colors.blue[600]};
    border: solid 1px ${theme.colors.blue[200]};
  `};
`;
